var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('dynpropbasedetail', {
    attrs: {
      "dynPropParam": _vm.dynPropParam
    },
    on: {
      "onSave": _vm.save
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "type": "number",
      "label": "Wert",
      "clearable": ""
    },
    model: {
      value: _vm.intValue,
      callback: function ($$v) {
        _vm.intValue = $$v;
      },
      expression: "intValue"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }